import mockData from '../../../features/widget-series-scoreboard/fixtures/liveSeries.json';

export default function* generator() {
    yield mockData;
}
